import { createToggleStore } from "@/store/createToggleStore";

const { useStore: useSwitchAccountModalStore } = createToggleStore();

export { useSwitchAccountModalStore };
